import PropTypes from "prop-types"
import React from "react"

class SeasonProgress extends React.Component {
  render() {
    return (
      <div className="season-progress hidden-xs">
        <div className="clearfix">
          <div
            className="season-date season-date-opening"
            data-toggle="tooltip"
            data-placement="top"
            title={this.props.openingDay}
          >
            Opening Day
          </div>
          <div
            className="season-date season-date-closing"
            data-toggle="tooltip"
            data-placement="top"
            title={this.props.closingDay}
          >
            Closing Day
          </div>
        </div>
        <div className="progress">
          <div
            className="progress-bar progress-bar-success"
            role="progressbar"
            aria-valuenow={Number(this.props.seasonPercentage)}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: `${Number(this.props.seasonPercentage)}%` }}
          />
          <span className="sr-only" />
        </div>
      </div>
    )
  }
}

SeasonProgress.propTypes = {
  openingDay: PropTypes.string.isRequired,
  closingDay: PropTypes.string.isRequired,
  seasonPercentage: PropTypes.number.isRequired,
}

export default SeasonProgress
